<template>
  <section class="product-gallery">
    <ul class="product-gallery__items">
      <CatalogProduct
        v-for="product in products"
        :key="product.id"
        :product="product"
        :class="product.getExtra('purchaseOrigin')"
      />
    </ul>
    <Pagination
      :current-page="filterStore.params.page"
      :pages="getPages"
      @on-page-change="onPageChange"
      @on-load-more="onLoadMore"
    />
  </section>
</template>

<script setup>
import CatalogProduct from "~/modules/shared/productCard/CatalogProduct.vue";
import { useCategoriesStore } from "~/store/categoriesStore";
import { trackEvent } from "~/utils/trackEvent";
import Pagination from "~/modules/shared/pagination/Pagination.vue";
import { Product } from "~/models/product.model";
import { useProductStore } from "~/store/productStore";
import { useProductFilterStore } from "~/store/productFilter.store";
import { setProductsPurchaseOrigin } from "~/utils/product.utils";

const props = defineProps({
  products: { type: Array, required: false, default: null },
  totalItems: { type: Number, required: false },
});

const categoriesStore = useCategoriesStore();
const filterStore = useProductFilterStore();
const { getMoreProducts } = useProductStore();

const category = computed(() => {
  return categoriesStore.getCategoryBySlug(useRoute().params.categorySlug);
});

watch(
  () => props.products,
  () => {
    setProductsPurchaseOrigin(props.products, "catalog");

    if (import.meta.client && null !== props.products) {
      const items = props.products.map((product, index) => {
        return {
          item_name: product.name.uk,
          item_id: product.code,
          price: product.getPrice(Product.PRICE_TYPE.CURRENT),
          item_brand: product.manufacturer.name,
          item_category: product.getMainCategory().name.uk,
          item_list_name: category.value?.code ?? "Обране",
          index: index + 1,
          quantity: 1,
        };
      });

      const event = {
        event: "view_item_list",
        ecommerce: {
          items,
        },
      };

      // Add view catalog to google-analytics
      trackEvent(event);
    }
  },
  { immediate: true },
);

const getPages = computed(() => {
  return Math.ceil(props.totalItems / filterStore.params.limit);
});

const onPageChange = (page) => {
  filterStore.setPage(page);
};

const onLoadMore = async (page) => {
  await getMoreProducts(page);
};
</script>

<style lang="scss" scoped>
.product-gallery {
  width: 100%;

  @include flex-container(column, flex-start);

  gap: 24px;
  margin-bottom: 32px;

  &__items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(288px, 1fr));
    gap: 8px;

    @include mobile {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
